/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ best: NonNullable<unknown> }} Workout_Live_Implausible_Above_BestInputs */

const en_us2_workout_live_implausible_above_best = /** @type {(inputs: Workout_Live_Implausible_Above_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`That's well above your best on this exercise: ${i?.best}.`)
};

const pt_br2_workout_live_implausible_above_best = /** @type {(inputs: Workout_Live_Implausible_Above_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`É bem mais que o seu melhor nesse exercício: ${i?.best}.`)
};

const es_419_workout_live_implausible_above_best = /** @type {(inputs: Workout_Live_Implausible_Above_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Es mucho más que tu mejor marca en este ejercicio: ${i?.best}.`)
};

const pt_pt2_workout_live_implausible_above_best = /** @type {(inputs: Workout_Live_Implausible_Above_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`É muito mais do que o teu melhor neste exercício: ${i?.best}.`)
};

const fr_fr2_workout_live_implausible_above_best = /** @type {(inputs: Workout_Live_Implausible_Above_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`C'est bien au-dessus de ton record sur cet exercice : ${i?.best}.`)
};

const de_de2_workout_live_implausible_above_best = /** @type {(inputs: Workout_Live_Implausible_Above_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das liegt weit über deiner Bestleistung bei dieser Übung: ${i?.best}.`)
};

const it_it2_workout_live_implausible_above_best = /** @type {(inputs: Workout_Live_Implausible_Above_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`È molto più del tuo massimo in questo esercizio: ${i?.best}.`)
};

/**
* | output |
* | --- |
* | "That's well above your best on this exercise: {best}." |
*
* @param {Workout_Live_Implausible_Above_BestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_implausible_above_best = /** @type {((inputs: Workout_Live_Implausible_Above_BestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Implausible_Above_BestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_implausible_above_best(inputs)
	if (locale === "es-419") return es_419_workout_live_implausible_above_best(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_implausible_above_best(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_implausible_above_best(inputs)
	if (locale === "de-DE") return de_de2_workout_live_implausible_above_best(inputs)
	if (locale === "it-IT") return it_it2_workout_live_implausible_above_best(inputs)
	return en_us2_workout_live_implausible_above_best(inputs)
});
export { workout_live_implausible_above_best as "workout-live.implausible_above_best" }